import "@/style/style.scss";
import Vue from "vue";

// import "@/plugins/vue-google-maps";
import vuetify from "@/plugins/vuetify";
import "@/plugins/vee-validate";
import "@/plugins/vue-axios";

import OurVueAuth from "@/auth/VueAuth";
import makeOAuthToken from "@/auth/makeOAuthToken";

import router from "./router";
import store from "./store";

import config from "@/config";

import App from "./MerchantApp.vue";

Vue.config.productionTip = false;

const oauthToken = makeOAuthToken("bookinglist_merchant");
const vueAuth = new OurVueAuth(
  {
    loginUrl: `${config.authURL}/oauth2/token`,
    refreshUrl: `${config.authURL}/oauth2/token`,
    oauthToken: oauthToken,
    scope: "bookinglist:merchant",
    clientId: "bookinglist_merchant"
  },
  {
    axios: Vue.axios,
    router: router
  }
);

Vue.prototype.$auth = vueAuth;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");

import "../registerServiceWorker";

const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
if (iOS) {
  document.body.classList.add("iOS");
}
